import { useParams, useNavigate } from 'react-router-dom'
import { EntityPageHeader } from '@/shared/components'
import { StructureForm } from '../components'
import { useStructure, useCreateStructure, useUpdateStructure } from '../hooks/use-structures'

export function StructureFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const isEdit = !!id

  const { data: structure, isLoading } = useStructure(id ? parseInt(id) : undefined)
  const createStructure = useCreateStructure()
  const updateStructure = useUpdateStructure()

  const handleSubmit = (data: { nom: string; type: string; ville?: string }) => {
    if (isEdit) {
      updateStructure.mutate(
        { id: parseInt(id!), data },
        { onSuccess: () => navigate('/administration/structures') },
      )
    } else {
      createStructure.mutate(data, {
        onSuccess: () => navigate('/administration/structures'),
      })
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={isEdit ? 'Modifier la structure' : 'Créer une structure'}
        backTo="/administration/structures"
      />
      <StructureForm
        structure={structure}
        onSubmit={handleSubmit}
        isPending={createStructure.isPending || updateStructure.isPending}
      />
    </div>
  )
}
